import '../../reset.css';
import '../../general_styles.css';
import './info_styles.css';

import NavigationMenu from '../../components/Navigation';
import Titleform from '../../components/Title_form';
import BtnTransition from '../../components/Buttons_Transition';

import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

function Yourinfo() {

    const [inputName, setInputName] = useState('');
    const [inputEmail, setInputEmail] = useState('');
    const [inputPhone, setInputPhone] = useState('');
    const [triedOnce, setTriedOnce] = useState(false);

    const [throwErrEmail, setThrowErrEmail] = useState(false);
    const [throwErrPhone, setThrowErrPhone] = useState(false);

    const navigate = useNavigate();

    function validation(e) {
        e.preventDefault();
        setTriedOnce(true);
        if (inputName === '' || inputEmail === '' || inputPhone === '') {
            setThrowErrEmail(true);
            setThrowErrPhone(true);
            return;
        }
        if (inputName.length >= 3 && throwErrEmail === false && throwErrPhone === false) {
            console.log('aee');
            navigate('/plan');
        }
    }

    const emailValidation = () => {
        const emailValue = inputEmail.trim();

        if (emailValue === '') {
            setThrowErrEmail(true);
        } else if (!isValidEmail(emailValue)) {
            setThrowErrEmail(true);
        }
        else {
            setThrowErrEmail(false);
        }
    }

    const isValidEmail = (email) => {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(String(email).toLowerCase()); //verify in the email that you passed on the parameter if it has some of this symbols 
    }

    const phoneValidation = (e) => {
        const phoneNumb = e.trim();
        if (phoneNumb.length !== 10 || phoneNumb.includes('-')) {
            setThrowErrPhone(true);
        }
/*         else if (phoneNumb[0] !== '+') {
            setInputPhone('+' + inputPhone);
        }  */else {
            setThrowErrPhone(false);
        }
    }

    return (
        <div className='page__container'>
            <div className='form__container'>
                <NavigationMenu />
                <form className='form' onSubmit={(e) => validation(e)}>
                    <Titleform title='Personal info' text='Please provide your name, email address and phone number' />
                    <div className='form__yourinfo'>
                        <div className='yourinfo__labels'>
                            <label>Name</label>
                            {inputName.length <= 2 && triedOnce == true ? <span>More than 2 letters required</span> : ''}
                        </div>
                        <input type='text' className='yourinfo__input' id='input__name' placeholder='e.g. Stephen King' value={inputName} onChange={e => setInputName(e.target.value)}></input>
                        <div className='yourinfo__labels'>
                            <label>Email Address</label>
                            {throwErrEmail && triedOnce == true ? <span>Provide a valid email</span> : ''}
                        </div>
                        <input type='text' className='yourinfo__input' id='input__email' placeholder='e.g. stephenking@lorem.com' value={inputEmail} onChange={(e) => { setInputEmail(e.target.value); emailValidation(); }}></input>
                        <div className='yourinfo__labels'>
                            <label>Phone Number</label>
                            {throwErrPhone && triedOnce == true ? <span>Provide a valid phone number</span> : ''}
                        </div>
                        <input type="number" inputmode="numeric" pattern="^[0-9]*$" className='yourinfo__input' id='input__phone' placeholder='e.g. +1 234 567 890' value={inputPhone} onChange={(e) => { setInputPhone(e.target.value); phoneValidation(e.target.value) }}></input>
                    </div>
                    <BtnTransition hasBackBtn={false} goToBack='/' hasNextBtn={true} />
                </form>
            </div>

        </div>
    );
}

export default Yourinfo;